module.exports = __webpack_public_path__ + "static/media/pic-history2.31ce6582.webp";